import Vue from 'vue'
import Router from 'vue-router'
import Home from '../components/Home'
import PrivacyPolicy from '../components/PrivacyPolicy'
//import About from '../components/About'


Vue.use(Router)


export default new Router({
  mode: 'history',
  routes: [
    {
        path: '/',
        name: 'home',
        component: Home 
    },
    {
      path: '/privacypolicy',
      name: 'privacypolicy',
      component: PrivacyPolicy
    },
    {
        path: '/#contact',
        name: 'contactus',
        component: Home 
      },
      {
        path: '/#about',
        name: 'about',
        component: Home 
      },
      {
        path: '/#services',
        name: 'services',
        component: Home 
      },
      {
        path: '/#certifications',
        name: 'certifications',
        component: Home 
      },
      {
        path: '/#carriers',
        name: 'carriers',
        component: Home 
      }
  ]
})

